import api, { request } from '../../api';
import { IErrorsStore } from '../errors/store';
import { IActionGroup, IStore } from '../index';
import { ISource, IStripeToken } from '../user/store';
import { IAdminClubCardStore } from './store';

export interface IAdminClubCardsActions extends IActionGroup {
  get: (clubId: number) => { adminClubCreditCard?: IAdminClubCardStore; errors?: IErrorsStore };
  update: (
    clubId: number,
    payment: IStripeToken | ISource
  ) => { adminClubCreditCard?: IAdminClubCardStore; errors?: IErrorsStore };
}

const actions: IActionGroup = {
  get: async (_: IStore, clubId: number) => {
    const response = await request.get(`${api.admin.clubs}${clubId}/card/`);

    if (response.error) {
      return { errors: { adminClubCreditCard: { msg: 'Error retrieving the club credit card.' } } };
    }

    return {
      adminClubCreditCard: response
    };
  },
  update: async (_: IStore, clubId: number, payment: IStripeToken | ISource) => {
    const data = { token: (payment as IStripeToken).id };
    const response = await request.post(`${api.admin.clubs}${clubId}/card/`, data);

    if (response.error) {
      return { errors: { adminClubCreditCard: { msg: 'Error updating the club credit card.' } } };
    }

    return {
      adminClubCreditCard: [response]
    };
  }
};

export default actions;
